import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UserDetails } from 'src/app/model/DocumentTemplate';
import { UpdateKpiUserMappingViewModel, UserKpiMasterViewModel } from 'src/app/model/KPI/user-kpi-master-view-model';
import { KpiService } from 'src/app/services/kpi.service';

@Component({
  selector: 'app-kpi-config-popup',
  templateUrl: './kpi-config-popup.component.html',
  styleUrls: ['./kpi-config-popup.component.css']
})
export class KpiConfigPopupComponent implements OnInit {

  @Output() close = new EventEmitter();
  @Output() ok = new EventEmitter<string>();
  userObject: any;
  loggedInUser: any;
  userKpiMasterViewModel: UserKpiMasterViewModel[] = [];
  showErrorMEssage: boolean = false;

  constructor(private kpiService: KpiService) { }

  ngOnInit() {
    let jsonString = localStorage.getItem("currentUser");
    this.userObject = JSON.parse(jsonString);
    this.getKpiUserMapping();
  }
  okClicked() {
    let updateKpiUserMappingViewModel: UpdateKpiUserMappingViewModel = new UpdateKpiUserMappingViewModel();
    updateKpiUserMappingViewModel.userKpiMasters = this.userKpiMasterViewModel;
    updateKpiUserMappingViewModel.loggedInUserEmail = this.userObject.userName;
    this.kpiService.updateKpiUserMapping(updateKpiUserMappingViewModel).subscribe({
      next: result => {
        if (result == "Success") {
          this.showErrorMEssage=false;
          this.getKpiUserMapping();
        }
        else if (result = "Failure") {
          this.showErrorMEssage=true;
        }
        
        this.ok.emit(result);
      }, error: err => {
        this.showErrorMEssage=true;
        this.ok.emit("Failure");
        console.error("failed to load KPI data for user", err);
      }
    })

  }
  cancelClicked(event) {
    this.getKpiUserMapping();
    this.showErrorMEssage=false;
    this.close.emit(event);
  }
  getKpiUserMapping() {
    let userDetails: UserDetails = new UserDetails();
    userDetails.loggedInUserEmail = this.userObject.loggedInUserEmail;
    this.kpiService.getKpiUserMapping(userDetails).subscribe({
      next: result => {
        this.userKpiMasterViewModel = result;
      }, error: err => {
        console.error("failed to load KPI data for user", err);
      }
    })
  }

}
